import BasicService from "../service/BasicService";

class PaymentService extends BasicService {
  constructor() {
    super();
  }

  getPaymentByDataAndOs(fromDate, toDate, osId) {
    let url = `/payments`;
    return this.axios.get(url, {
      params: {
        fromDate,
        toDate,
        osId,
      }
    }).then(request => request.data);
  }
  addPaymentByDate(payment) {
    let url = `/payments`;
    return this.axios.post(url, payment).then(request => request.data);
  }

  updatePaymentByDate(payment) {
    let url = `/payments/${payment.transactionId}`;
    return this.axios.put(url,payment).then(request => request.data);
  }
  deletePaymentByDate(payment) {
    let url = `/payments/${payment}`;
    return this.axios.delete(url).then(request => request.data);
  }

  getPaymentByItemId(itemId) {
    let url = `/orders/${itemId}/payments`;
    return this.axios.get(url).then(response => response.data);
  }

  /**
   *
   * @param {Number} itemId
   * @param {Number} transactionId
   * @param {Payment} payment - {"transactionId": Number,"osId": Number,"itemId": Number,"itemValue": Number,"amount": Number,"payment": Number,"balance": Number}}
   */
  updatePayment(itemId, transactionId, payment) {
    let url = `/orders/${itemId}/payments/${transactionId}`;
    return this.axios.put(url, payment).then(response => response.data);
  }
  
}

const paymentService = new PaymentService();
export default paymentService;
